import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import { useNeedPay } from 'modules/admin';
import SolarIcon from 'components/icons/SolarIcon';
import { useVendors } from './context/VendorsProvider';

interface VendorToolBarProps {
    setEditVendorId: (vendorId: number) => void;
}

const VendorToolBar = ({ setEditVendorId }: VendorToolBarProps) => {
    const { t } = useTranslation(['Vendors', 'common']);
    const { auth } = useAuth();
    const { triggerListReset, triggerListRefresh } = useVendors();
    const { needPay } = useNeedPay();
    const canEdit = hasUserAccess(auth?.user, 'prodEdit');

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                {canEdit && (
                    <Button
                        className="fs-14 ms-1"
                        size="sm"
                        variant="success"
                        onClick={(e) => {
                            e.currentTarget.blur();
                            if (needPay()) return;
                            setEditVendorId(0);
                        }}
                    >
                        <SolarIcon name="plus" className="fs-14 p-0" />
                        <span className="ms-1">{t('toolAddVendor')}</span>
                    </Button>
                )}

                <ListToolBarActions onReset={triggerListReset} onRefresh={triggerListRefresh} />
            </div>
        </div>
    );
};

export default VendorToolBar;
